import { render, staticRenderFns } from "./codeModal.vue?vue&type=template&id=4b55f9d1&scoped=true"
import script from "./codeModal.vue?vue&type=script&lang=js"
export * from "./codeModal.vue?vue&type=script&lang=js"
import style1 from "./codeModal.vue?vue&type=style&index=1&id=4b55f9d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b55f9d1",
  null
  
)

export default component.exports